module.exports = __webpack_public_path__ + "img/icon-ai-blue.b4d8c26c.svg";